export default __webpack_public_path__ + "static/media/photosDefaultRight.36bdc37f.png";